import { LOCAL_STORAGE_GRID_KEYS } from "../../../_constants";
import { formatDate } from "../../../_helpers";
import { getGridContextMenuList } from "../../../_helpers/getGridContextMenuList";
import { LabelColumnV2, LinkColumnV2 } from "../../../components/DataGridV2/DataColumnsV2";

 const { webApiUrl } = window.appConfig;

export const getCufXmlImportColumns = ({ t,
    keyPrefix,
    i18n,
    apiRef,
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.CUF_XML_IMPORTS_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
        getValueForCopy: (rowData, extraData) => {
            let text = ""
            switch (extraData.fieldName) {
                case "insertedOn":
                    text = rowData?.insertedOn ? formatDate(new Date(rowData?.insertedOn), true) : ""
                    break;
                default:
                    text = rowData[extraData.fieldName]
                    break;
            }
            return text
        },
    })

    return [
        {
            download: true,
            print: true,
            field: "source",
            headerName: t("settings.importCufXml.source"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.source}
                        cellSubMenuOptions={{ options: getOptions({ field: "source", isQuickFilterDisplay: Boolean(rowData.source) }), extraData: { fieldName: "source" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "insertedOn",
            headerName: t("general.insertedOn"),
            type: 'dateTime',
            valueGetter: (params) => {
                if (!params) return "";
                return new Date(params);
            },
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                const insertedOn = rowData?.insertedOn
                    ? formatDate(new Date(rowData?.insertedOn), true)
                    : null;
                return (
                    <LabelColumnV2
                        label={insertedOn}
                        cellSubMenuOptions={{ options: getOptions({ field: "insertedOn", isQuickFilterDisplay: Boolean(insertedOn) }), extraData: { fieldName: "insertedOn", type: 'dateTime' } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "insertedBy",
            headerName: t("general.insertedBy"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.insertedBy}
                        cellSubMenuOptions={{ options: getOptions({ field: "insertedBy", isQuickFilterDisplay: Boolean(rowData.insertedBy) }), extraData: { fieldName: "insertedBy" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "fileName",
            headerName: t('settings.importCufXml.fileName'),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LinkColumnV2
                        label={rowData.fileName}
                        download={rowData.fileName.toString()}
                        onClick={(event) => event.stopPropagation()}
                        target="_blank"
                        to={`${webApiUrl}api/ImportExport/GetCufXmlFile/${rowData?.id}`}
                        cellSubMenuOptions={{ options: getOptions({ field: "fileName", isQuickFilterDisplay: Boolean(rowData.fileName) }), extraData: { fieldName: "fileName" } }}
                        request={rowData}
                    />
                );
            },
        },
    ];
}


